<template>
    <pcg-modal
        class="hearingEventApplicationModal eventApplicationModal"
        :isActive="isActiveModal"
        :bgImage="true"
    >
        <template v-if="eventData && isDisplay('default')">
            <div class="header u-text-center">
                <div class="status">
                    <template v-if="isReservoir">リザーバー応募受付</template>
                    <template v-else-if="isArrivingFirst">先着応募受付</template>
                    <template v-else-if="isDrawing">抽選応募受付</template>
                </div>
                <div class="c-title c-title-page u-mb">
                    {{ eventData.orgEventTitle ? eventData.orgEventTitle : eventData.eventTitle }}<br>
                    {{ eventData.regulationTitle ? '【' + eventData.regulationTitle + 'レギュレーション】' : '' }}
                </div>
                <div
                    v-if="eventData.leagueTitle"
                    class="league"
                >◆{{ eventData.leagueTitle + 'リーグ' }}</div>
            </div>

            <div class="detail">
                <div class="date u-text-center">
                    <div class="date-day">{{ dataFormat(eventData.eventDate, 2) }}</div>
                    <div class="date-time">{{ dataFormat(eventData.eventStartedAt, 4) + '～' + (eventData.eventEndedAt ? dataFormat(eventData.eventEndedAt,4) : '') }}</div>
                    <div class="supplement">{{ eventData.eventDaySupply }}</div>
                </div>
                <div class="detail-table">
                    <div class="shopTab">
                        <span class="tab">主催者</span>
                        <span>{{ eventData.eventTypeId === 1 ? '株式会社ポケモン' : eventData.shopName }}</span>
                    </div>
                    <div class="addressTab">
                            <span class="tab">会場</span>
                            <span class="postcode">{{ (eventData.zipCode ? '〒' + zipCodeFormat(eventData.zipCode) : '') + ' ' + (eventData.address ? eventData.address : '') }} </span>
                            <span>{{ eventData.venue }}</span>
                    </div>
                    <div>
                        <template v-if="eventData.entryFee">
                            <span class="tab">参加費</span>{{ displayEntryFee(eventData.entryFee) }}
                        </template>
                        <template v-else>
                            <span class="tab">参加費</span>無料
                        </template>
                    </div>
                    <div>
                        <span class="tab">定員</span>{{ eventData.capacity + '人' }}
                    </div>
                </div>
            </div>

            <div
                v-if="isArrivingFirst || isDrawing"
                class="eventApplication-start"
            >
                <div class="title">
                    <template v-if="isAdditionalEntry">追加応募受付期間</template>
                    <template v-else-if="isArrivingFirst">先着応募受付期間</template>
                    <template v-else-if="isDrawing">抽選応募受付期間</template>
                </div>
                <div
                    v-if="!isAdditionalEntry"
                    class="date"
                >
                    <span v-if="!isEntrying">{{ dataFormat(eventData.entryStartedAt, 1) }} </span>〜
                    <span>{{ dataFormat(eventData.entryEndedAt, 1) }}</span>
                </div>
                <div
                    v-else
                    class="date"
                >
                    <span v-if="!isEntrying">{{ dataFormat(eventData.additionalEntryStartDate, 1) }} </span>〜
                    <span>{{ dataFormat(eventData.additionalEntryEndDate, 1) }}</span>
                </div>
                <div
                    v-if="isDrawing"
                >
                    <template v-if="eventData.entryTypeId === 2">
                        抽選結果発表：{{ dataFormat(eventData.lotteryDeadline,7) }}&emsp;※発表の時刻は前後する場合がございます。
                    </template>
                    <template v-else>
                        抽選結果発表：{{ dataFormat(eventData.lotteryDeadline,1) }}
                    </template>
                </div>
            </div>

            <div class="c-title c-title-h3 u-mb-20">ヒアリング項目</div>
            <div class="eventApplication-hearingCotent u-mb">
                <template
                    v-for="item in hearingItems"
                    :key="`form-${item.id}`"
                >
                    <div
                        v-if="item.answerType === 1"
                        :id="`hearingItemId_${item.id}`"
                        class="hearingContent"
                    >
                        <div class="hearingContent-title">
                            {{ item.question }}
                        </div>
                        <div class="hearingContent-item">
                            <div
                                class="c-input c-input-select"
                                :class="{ 'c-input-error': item.isError }"
                            >
                                <select v-model="item.answer">
                                    <option :value="null">選択してください</option>
                                    <option
                                        v-for="option in item.options"
                                        :key="`select${item.id}${option.id}`"
                                        :value="option.id"
                                    >{{ option.optionText }}</option>
                                </select>
                            </div>
                        </div>
                        <p
                            v-if="item.isError"
                            class="error u-text-warning-icon u-text-small u-text-bold u-mt-sm"
                        >
                            必須項目です。
                        </p>
                    </div>
                    <div
                        v-if="item.answerType === 2"
                        :id="`hearingItemId_${item.id}`"
                        class="hearingContent"
                    >
                        <div class="hearingContent-title">
                            {{ item.question }}
                        </div>
                        <div class="hearingContent-item">
                            <div
                                v-for="option in item.options"
                                :key="`select${item.id}${option.id}`"
                                :class="{'c-input-error': item.isError}"
                                class="c-checkbox"
                            >
                                <input
                                    v-model="item.answer"
                                    :id="`hearingCheckbox-input-${item.id}_${option.id}`"
                                    :value="option.id"
                                    type="checkbox"
                                />
                                <label
                                    :for="`hearingCheckbox-input-${item.id}_${option.id}`"
                                >{{ option.optionText }}</label>
                            </div>
                        </div>
                        <p
                            v-if="item.isError"
                            class="error u-text-warning-icon u-text-small u-text-bold u-mt-sm"
                        >
                            必須項目です。
                        </p>
                    </div>
                    <div
                        v-if="item.answerType === 3"
                        :id="`hearingItemId_${item.id}`"
                        class="hearingContent"
                    >
                        <div class="hearingContent-title">
                            {{ item.question }}
                        </div>
                        <p class="u-text-exsmall">(1000文字以内で入力してください)</p>
                        <div class="hearingContent-item">
                            <textarea
                                v-model="item.answer"
                                class="c-input c-input-textarea"
                                :class="{'c-input-error': item.isError}"
                            ></textarea>
                        </div>
                        <p
                            v-if="item.isError"
                            class="error u-text-warning-icon u-text-small u-text-bold u-mt-sm"
                        >
                            {{ item.isErrorMaxSize ? '1000文字以内で入力してください。' : '必須項目です。' }}
                        </p>
                    </div>
                </template>
            </div>

            <div class="c-title c-title-h3 u-mb-20">同意事項</div>
            <div
                v-if="age < 18"
                class="eventApplication-agreement u-mb"
                :class="{'eventApplication-agreement-error': isFormParentalConsent}"
            >
                <div class="eventApplication-agreement-title">保護者の同意</div>
                <div class="u-mb">
                    <p>18歳未満の方は、保護者の同意が必要です。<br class="u-display-pc">
                    同意を得た上で、チェックボックスにチェックを入れてください。</p>
                </div>
                <div class="eventApplication-agreement-checkbox">
                    <div class="c-checkbox">
                        <input
                            id="agreement1"
                            name="agreement1"
                            type="checkbox"
                            v-model="formParentalConsent" >
                        <label for="agreement1">
                            保護者の同意を得ました
                        </label>
                    </div>
                </div>
                <div
                    v-if="isFormParentalConsent"
                    class="u-text-warning-icon u-text-small u-text-bold u-mt-sm"
                >
                    保護者の同意にチェックをしてください。
                </div>
            </div>
            <div
                class="eventApplication-agreement u-mb"
                :class="{'eventApplication-agreement-error': isFormTermsOfService}"
            >
                <div class="u-mb">
                    <p>
                        「<a class="c-link" :href="getPolicyLinkURL()" target="_blank">プレイヤーズクラブ利用規約</a>」をご確認の上、同意いただける方は、「同意する」にチェックを入れ、「応募する」ボタンをクリックしてください。
                    </p>
                </div>
                <div class="eventApplication-agreement-checkbox">
                    <div class="c-checkbox">
                        <input
                            id="agreement2"
                            name="agreement2"
                            type="checkbox"
                            v-model="formTermsOfService" >
                        <label for="agreement2">
                            利用規約に同意する
                        </label>
                    </div>
                </div>
                <div
                    v-if="isFormTermsOfService"
                    class="u-text-warning-icon u-text-small u-text-bold u-mt-sm"
                >
                    同意するにチェックをしてください。
                </div>
            </div>
            <div
                v-if="isReservoir"
                class="eventApplication-reservoir"
            >
                <div class="eventApplication-reservoir-text u-text-danger u-text-center u-text-bold">
                    この受付は、リザーバー応募です。
                </div>
                <div class="status-reservoir u-text-danger">
                    キャンセルが発生した際に、繰上げでの参加のご連絡を<span class="u-text-bold">{{  dataFormat(eventData.eventDate, 5) + '18:00' }}</span>までにメールまたはマイページ内「出場予定のイベント」にてお知らせします。
                </div>
            </div>
            <div
                v-else-if="isDrawing"
                class="eventApplication-reservoir"
            >
                <div class="eventApplication-reservoir-text u-text-center">
                    <p>このイベントは抽選応募になります。</p>
                    <p>
                        抽選の結果は<span class="u-text-bold"><template v-if="eventData.entryTypeId === 2">{{ dataFormat(eventData.lotteryDeadline, 8) }}</template><template v-else>{{ dataFormat(eventData.lotteryDeadline,3) }}</template></span>までにメールまたはマイページ内「出場予定のイベント」にてお知らせします。</p>
                </div>
                <div class="status-reservoir u-text-danger u-text-center">
                    抽選結果には、「参加確定」<template v-if="eventData.reservoirCount > 0">「<router-link
                        :to="{name: 'Faq', hash: '#reservoir'}"
                        rel="stylesheet"
                        class="c-link"
                        target="_blank"
                    >リザーバー当選</router-link>」</template>「落選」があります。
                </div>
            </div>
            <template v-else>
                <div class="u-text-center u-mb">
                    <p>このイベントは先着応募になります。</p>
                    <p>結果は、マイページ内「出場予定のイベント」で確認できます。</p>
                </div>
            </template>
            <template v-if="isTimeOut">
                <div class="u-text-danger u-text-center">
                    <p class="u-text-bold">ただいまサーバーが込み合っています</p>
                    <p>イベントへのエントリーは完了できませんでした。しばらく待って再度アクセスください。</p>
                </div>
            </template>
            <div
                class="status-apply c-gradientBox u-mb-exlg"
                :class="{
                    'priority-top': eventData.priorityFlg === 1 && !isUsedPriority,
                    'priority-bottom': eventData.priorityFlg === 1 && isUsedPriority
                }"
            >
                <template v-if="eventData.priorityFlg === 1 && !isUsedPriority && !isAdditionalEntry">
                    <div class="priorityText">
                        <div class="priorityText-title">第1希望指定</div>
                        <div class="priorityText-text">
                            <p>「第1希望」にチェックをつけたエントリーが、<br>他のエントリーよりも優先して当選しやすくなります。</p>
                            <p>（「第1希望」の設定は、同じ種類のイベントに対して1つまでです。）</p>
                        </div>
                        <div class="eventApplication-agreement-checkbox">
                            <div class="c-checkbox">
                                <input
                                    id="priority_application"
                                    name="priority_application"
                                    type="checkbox"
                                    v-model="formPriorityApplication"
                                >
                                <label for="priority_application">
                                    第1希望
                                </label>
                            </div>
                        </div>
                        <div class="faqLink">
                            <router-link
                                :to="{name: 'Faq', hash: '#priority'}"
                                rel="stylesheet"
                                class="c-link"
                                target="_blank"
                            >第１希望とは</router-link>
                        </div>
                    </div>
                </template>
                <button
                    @click="send()"
                    class="c-btn c-btn-primary"
                >応募する</button>
            </div>
        </template>
        <complete
            v-if="isDisplay('complete')"
            :eventData="eventData"
            :isArrivingFirst="isArrivingFirst"
            :isDrawing="isDrawing"
            :isReservoir="isReservoir"
            :isAdditionalEntry="isAdditionalEntry"
            :sendMailAddress="sendMailAddress"
        ></complete>
        <failed
            v-if="isDisplay('failed')"
            :eventData="eventData"
            :isArrivingFirst="isArrivingFirst"
            :isDrawing="isDrawing"
            :isReservoir="isReservoir"
            :message="message"
            :isEntryMessage="isEntryMessage"
        ></failed>
    </pcg-modal>
</template>

<script>
import pcgModal from '@/component/Modal.vue'

import stateData from '../methods/data.js'

import complete from './HearingEventApplicationModal/HearingEventApplicationComplete.vue'
import failed from './HearingEventApplicationModal/HearingEventApplicationFailed.vue'

export default {
    name: 'HearingEventApplicationModal',
    mixins: [stateData],
    components: {
        pcgModal,
        complete,
        failed,
    },
    props: {
        isActiveModal: {
            type: Boolean,
            default: false,
        },
        eventData: {
            type: Array,
            require: true,
        },
        age: {
            type: Number,
            require: true,
        },
        isArrivingFirst: {
            type: Boolean,
            default: false,
        },
        isDrawing: {
            type: Boolean,
            default: false,
        },
        isReservoir: {
            type: Boolean,
            default: false,
        },
        eventHoldingId: {
            type: String,
            require: true,
        },
        isEntrying: {
            type: Boolean,
            default: false,
        },
        isAdditionalEntry: {
            type: Boolean,
            default: false,
        },
        isUsedPriority: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            modalStatus: 'default',
            formParentalConsent: false,
            isFormParentalConsent: false,
            formTermsOfService: false,
            isFormTermsOfService: false,
            hearingItems: [],
            formPriorityApplication: true,

            scrollElementId: '',
            sendMailAddress: '',
            message: '',
            isEntryMessage: true,
            isTimeOut: false,
        }
    },
    computed: {

    },
    created: function() {
        this.modalStatus = 'default'
    },
    mounted: function() {
        this.hearingItems = structuredClone(this.eventData.hearingItems)
        for (const [key] of Object.entries(this.hearingItems)) {
            if (this.hearingItems[key].answerType === 2) {
                this.hearingItems[key].answer = []
            } else {
                this.hearingItems[key].answer = null
            }
            this.hearingItems[key].isError = false
            this.hearingItems[key].isErrorMaxSize = false
        }
    },
    methods: {
        isDisplay(status) {
            return this.modalStatus === status
        },
        zipCodeFormat(zipCode) {
            if (zipCode === null || zipCode === '') {
                return ''
            }
            const zip = String(zipCode)

            return zip.includes('-') ? zip : zip.slice(0, 3) + '-' + zip.slice(3)
        },
        displayEntryFee(entryFee) {
            if (!isNaN(entryFee)) {
                return entryFee + '円'
            } else {
                return entryFee
            }
        },
        getPolicyLinkURL() {
            const base_url = process.env.VUE_APP_TRAINERS_WEB_URL
            return base_url + '/event/players_policy/'
        },
        isInvalid() {
            let retBool = false

            for (const [key] of Object.entries(this.hearingItems)) {
                this.hearingItems[key].isError = false
                this.hearingItems[key].isErrorMaxSize = false
            }
            this.isFormParentalConsent = false
            this.isFormTermsOfService = false
            this.scrollElementId = ''

            for (const [key] of Object.entries(this.hearingItems)) {
                if (
                    this.hearingItems[key].answerType === 2 &&
                    this.hearingItems[key].answer.length === 0
                ) {
                    retBool = true
                    this.hearingItems[key].isError = true
                    this.scrollElementId = this.scrollElementId === '' ? `hearingItemId_${this.hearingItems[key].id}`: this.scrollElementId
                } else {
                    if (this.hearingItems[key].answer === null || this.hearingItems[key].answer.length === 0) {
                        retBool = true
                        this.hearingItems[key].isError = true
                        this.hearingItems[key].isErrorMaxSize = false
                        this.scrollElementId = this.scrollElementId === '' ? `hearingItemId_${this.hearingItems[key].id}`: this.scrollElementId
                    } else if (this.hearingItems[key].answer.length > 1000) {
                        retBool = true
                        this.hearingItems[key].isError = true
                        this.hearingItems[key].isErrorMaxSize = true
                        this.scrollElementId = this.scrollElementId === '' ? `hearingItemId_${this.hearingItems[key].id}`: this.scrollElementId
                    }
                }
            }

            if (this.age < 18 && !this.formParentalConsent) {
                this.isFormParentalConsent = true
                retBool = true
                this.scrollElementId = this.scrollElementId === '' ? 'agreement1': this.scrollElementId
            }

            if (!this.formTermsOfService) {
                this.isFormTermsOfService = true
                retBool = true
                this.scrollElementId = this.scrollElementId === '' ? 'agreement2': this.scrollElementId
            }

            return retBool
        },
        setHearingItems() {
            const sendHearingItems = []

            for (const [key] of Object.entries(this.hearingItems)) {
                if (this.hearingItems[key].answerType === 2 && this.hearingItems[key].answer.length > 1) {
                    const answerList = this.hearingItems[key].answer
                    answerList.forEach(answer => {
                        sendHearingItems.push({
                            id: this.hearingItems[key].id,
                            answerType: this.hearingItems[key].answerType,
                            answer: answer
                        })
                    })
                } else {
                    sendHearingItems.push({
                        id: this.hearingItems[key].id,
                        answerType: this.hearingItems[key].answerType,
                        answer: this.hearingItems[key].answer
                    })
                }
            }

            return sendHearingItems
        },
        send() {
            this.isTimeOut = false

            if (this.isInvalid())
            {
                const element = document.getElementById(this.scrollElementId)
                element.scrollIntoView({block: 'center'})
                return
            }

            const params = new URLSearchParams()
            params.append('event_holding_id', this.eventData.id)
            params.append('event_type_id', this.eventData.eventTypeId)

            this.setHearingItems().forEach((item, index) => {
                for (const [key] of Object.entries(item)) {
                    params.append(`event_hearing_items[${index}][${key}]`, item[key])
                }
            })

            if (this.isArrivingFirst) {
                params.append('lottery_deadline', '')
            } else if (this.eventData.entryTypeId === 2) {
                params.append('lottery_deadline', this.dataFormat(this.eventData.lotteryDeadline, 7))
            } else {
                params.append('lottery_deadline', this.dataFormat(this.eventData.lotteryDeadline, 1))
            }

            if (this.eventData.deckRegistFlg) {
                params.append('deck_regist_ended_at', this.dataFormat(this.eventData.deckRegistEndedAt, 1))
            } else {
                params.append('deck_regist_ended_at', '')
            }

            params.append('title', (this.eventData.orgEventTitle ? this.eventData.orgEventTitle : this.eventData.eventTitle))
            params.append('league', this.eventData.leagueTitle + 'リーグ')
            params.append('event_date', this.dataFormat(this.eventData.eventDate, 2))
            params.append('event_started_at', this.dataFormat(this.eventData.eventStartedAt, 4))
            params.append('venue', this.eventData.venue)
            params.append('access', this.eventData.access)
            params.append('entry_fee', this.eventData.entryFee)
            params.append('capacity', this.eventData.capacity + '人')
            if(this.eventData.priorityFlg)
            {
                params.append('priority_application', this.formPriorityApplication ? ( !this.isUsedPriority ? 1 : 0 ) : 0)
            } else {
                params.append('priority_application', 0)
            }

            this.axios.post('/event_participation', params)
            .then(response => {
                this.sendMailAddress = response.data.mailaddress
                this.modalStatus = 'complete'
            })
            .catch(err =>{
                this.err = err.response.data.message
                this.message = err.response.data.message
                this.isEntryMessage = err.response.data.isEntryMessage === '0' ? false:true
                if (err.response.data.code === 408)
                {
                    this.isTimeOut = true
                } else {
                    this.modalStatus = 'failed'
                }
            })

            return
        }
    }
}
</script>

<style lang="scss" scoped>
@use '~@/assets/style/global' as g;
@use '../style/applicationModal';

.hearingContent {
    &:not(:first-child) {
        margin-top: 40px;

        @include g.sp {
            margin-top: 32px;
        }
    }

    .hearingContent-title {
        @include g.font-normal;

        @include g.sp {
            @include g.font-sm;
        }
    }
    .hearingContent-item {
        margin-top: 20px;

        @include g.sp {
            margin-top: 18px;
        }

        .c-checkbox {
            &:not(:first-child) {
                margin-top: 20px;

                @include g.sp {
                    margin-top: 14px;
                }
            }
        }
    }
}
</style>
